import { render, staticRenderFns } from "./NormalSearchNav477.vue?vue&type=template&id=3b1a820a&scoped=true&"
import script from "./NormalSearchNav477.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav477.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a820a",
  null
  
)

export default component.exports